import React, { useState } from "react";
import logo from "../assets/images/logo.svg";
import Background from "../assets/images/background_page.png";
import UserServices from "./../services/UserServices";
import TenantServices from "../services/TenantServices";
import { useEffect } from "react";
import { HollowDotsSpinner } from "react-epic-spinners";

export default function SignIn() {
  const [loading, setLoading] = useState({ loading: false });
  const errors = {
    nameIsValidated: "",
    nameError: "",
    passwordIsValidated: "",
    passwordError: "",
    formIsSubmitting: false,
  };
  const [formValues, setFormValues] = useState({
    userName: "",
    password: "",
  });
  const [formState, setFormState] = useState(errors);

  const formHandler = {
    emailHandler: (event) => {
      setFormValues({ ...formValues, userName: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          emailError: "Username cannot be empty",
          emailIsValidated: false,
        });
        return;
      }

      setFormState({
        ...formState,
        emailError: "",
        emailIsValidated: true,
      });
    },
    passwordHandler: (event) => {
      setFormValues({ ...formValues, password: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          passwordError: "Password cannot be empty",
          passwordIsValidated: false,
        });
        return;
      }
      setFormState({
        ...formState,
        passwordError: "",
        passwordIsValidated: true,
      });
    },
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading({ loading: true });
    const isFilledCorrectly =
      formState.emailIsValidated && formState.passwordIsValidated;
    setFormState({ ...formState, formIsSubmitting: true });
    if (isFilledCorrectly) {
      const data = {
        userName: formValues.userName,
        password: formValues.password,
      };
      const validate = await UserServices.userLogin(data);
      if (validate == null) {
        setLoading({ loading: true });
      } else {
        console.log("validate", validate);
        sessionStorage.setItem("authToken", validate.data);
        await generateTenant()
        .then(() =>  {
          setLoading({ loading: false })
          window.location.href = "/token"
      })
        .catch((err) => (
          console.log("failed to generate tenant Id")
        ))
       
      }
    }
    setLoading({ loading: false });
  };
  const generateTenant = async () => {
    const tenantId = await TenantServices.getTenant("PremiumTrust");
    if (tenantId && tenantId.data && tenantId.data.id) {
      sessionStorage.setItem("tenantId", tenantId.data.id);
    } else {
      return;
    }
  };
  useEffect(() => {
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("tenantId");
    generateTenant();
  }, []);
  return (
    <>
      <div className="h-screen flex">
        <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
              <img className="h-12 w-auto" src={logo} alt="logo" />
              <h2 className="mt-8 text-3xl font-bold text-gray-900">
                Welcome Back!
              </h2>
              <p className="mt-2 text-sm text-gray-600">
                Please log in to your PremiumTrust Bank Account
              </p>
            </div>

            <div className="mt-8">
              <div className="mt-6">
                <form onSubmit={submit} className="space-y-6">
                  <div>
                    <label
                      htmlFor="userName"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Username
                    </label>
                    <div className="mt-1">
                      <input
                        id="userName"
                        name="userName"
                        type="text"
                        placeholder="Enter your username"
                        autoComplete="text"
                        value={formValues.userName}
                        onChange={formHandler.emailHandler}
                        required
                        className="appearance-none block w-full pb-4 pt-4 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                      {!formState.emailIsValidated && formState.emailError && (
                        <div className="text-red-800">
                          {formState.emailError}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="space-y-1">
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Password
                    </label>
                    <div className="mt-1">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        placeholder="Enter password"
                        value={formValues.password}
                        onChange={formHandler.passwordHandler}
                        autoComplete="current-password"
                        required
                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                      {!formState.passwordIsValidated &&
                        formState.passwordError && (
                          <div className="text-red-800">
                            {formState.passwordError}
                          </div>
                        )}
                    </div>
                  </div>

                  {loading.loading === false ? (
                    <div>
                      <button
                        type="submit"
                        onClick={submit}
                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white btn-primary"
                      >
                        Login
                      </button>
                    </div>
                  ) : (
                    <HollowDotsSpinner size={15} color="#4D627E" />
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="hidden lg:block relative w-0 flex-1">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src={Background}
            alt=""
          />
        </div>
      </div>
    </>
  );
}
